<div class="modal-header">
  <h4 class="modal-title">{{'year'|translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="yearForm" (ngSubmit)="onFormSubmit()" id="ngForm">
    <div class="row">
      <div class="col-md-4">
        <label class="form-label">{{'year'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm" type="text" placeholder="Ex. 2024" formControlName="year" [ngClass]="{'is-invalid': fc['year'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['year'].errors?.['required']">{{'this field is required'|translate}}</small>
        <div class="invalid-feedback" *ngIf="fc['year'].errors?.['serverError']">
          {{ fc['year'].errors?.['serverError'] }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="form-label">{{'start at'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm" type="date" placeholder="Ex. 2024-01-10" formControlName="startAt" [ngClass]="{'is-invalid': fc['startAt'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['startAt'].errors?.['required']">{{'this field is required'|translate}}</small>
      </div>
      <div class="col-md-4">
        <label class="form-label">{{'end at'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm" type="date" placeholder="Ex. 2024-01-31" formControlName="endAt" [ngClass]="{'is-invalid': fc['endAt'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['endAt'].errors?.['required']">{{'this field is required'|translate}}</small>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">

    <button form="ngForm" (submit)="onFormSubmit()" style="margin-right: 10px" type="submit" class="btn btn-sm btn-primary" [disabled]=saving>
      <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
              <ng-template #isSaving>
                <i class="fa fa-spin fa-spinner me-2"></i>
              </ng-template>
              {{ 'save'|translate }}
    </button>

    <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">
      <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>{{'close'|translate}}
    </button>

</div>














